import styled from "styled-components";

export const AvailabilityWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
`;

export const AvailabilityDescWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  display: grid;
  .fui-Label {
    font-size: 12px;
  }
`;